import React, { useMemo } from 'react';
import { ContentstackClientContext, } from './contentstack-client-context';
import { ContentstackService } from '../services/contentstack-service';
export const ContentstackClientContextProvider = ({ children, config }) => {
    const contentstackClient = useMemo(() => new ContentstackService(config), [config]);
    const providerValue = useMemo(() => ({
        contentstackClient,
    }), [contentstackClient]);
    return (React.createElement(ContentstackClientContext.Provider, { value: providerValue }, children));
};
//# sourceMappingURL=ContentstackClientContextProvider.js.map